module.exports = __webpack_public_path__ + "img/colored-paper-9.ce56a1f8.png";